import React, { useState, useEffect, useRef, PropsWithChildren } from 'react';
import styled from 'styled-components';

interface Props {
  duration?: number;
}

export default function FadeIn({ children, duration }: PropsWithChildren<Props>) {
  const [fadeIn, setFadeIn] = useState(false);
  const domRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setFadeIn(true);
        }
      });
    });

    if (domRef && domRef.current) {
      observer.observe(domRef.current);
    }
  }, []);

  return (
    <Fade $fadeIn={fadeIn} $duration={duration} ref={domRef}>
      {children}
    </Fade>
  );
}

interface FadeWrapProps {
  $fadeIn: boolean;
  $duration?: number;
}

const Fade = styled.div<FadeWrapProps>`
  opacity: 0;
  width: 100%;
  transition: opacity ${({ $duration }) => ($duration ? `${$duration}ms` : '1200ms')} ease-in-out;
  will-change: opacity;
  ${({ $fadeIn }) => ($fadeIn ? `opacity: 1;` : '')}
`;
